import { render, staticRenderFns } from "./SectionNotification.vue?vue&type=template&id=f481e20e&scoped=true&"
import script from "./SectionNotification.vue?vue&type=script&lang=js&"
export * from "./SectionNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f481e20e",
  null
  
)

export default component.exports